import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IstekOlayTuru } from '@/src/service/fikoyt.istek.service';
import { debounce } from '@/src/service/fikoyt-ui/decorators/debounce';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FikoYTIstekSayfalama } from '@/src/service/modules/fikoyt-istek-kok/fikoyt-istek-sayfalama';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
// import { Debounce } from '../../FikoYT/decorators/FikoRator.decorators';
import { NzColorPickerModule } from 'ng-zorro-antd/color-picker';

declare var $: any;

@Component({
  selector: 'fikoyt-bayrak-editor',
  templateUrl: './.component.html',
  styles: [`
    ::ng-deep .prefix-ustte {

.ant-input-prefix,
.ant-input-suffix {
   align-items: unset;
   
}
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, CommonModule, FormsModule, NzWaveModule, NzInputModule, NzButtonModule, NzIconModule, NzPaginationModule, NzPopconfirmModule, NzColorPickerModule],
})
export class FikoYTBayrakEditor extends FikoYTKokBilesenComponent implements OnDestroy {
  /** */
  @Input() baslik = "Bayrak Editör";
  /** */
  @Input() saltOkunur = false;
  /** */
  private SOLSIMGE: any = {
    aciklama: "FikoYT Bayrak Açıklaması",
    baslik: "FikoYT",
    renkArka: "blue",
    renkYazi: "white",
  };
  public get bayrak(): any {
    return this.SOLSIMGE;
  }
  @Input() public set bayrak(v: any) {
    if (!v) v = {
      aciklama: "FikoYT Bayrak Açıklaması",
      baslik: "FikoYT",
      renkArka: "blue",
      renkYazi: "white",
    };
    this.SOLSIMGE = JSON.parse(JSON.stringify(v));;
    this.bayrakChange.emit(this.SOLSIMGE);
  }
  @Output() bayrakChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() tiklandiKaydet: EventEmitter<any> = new EventEmitter<any>();
  @Output() kapandi: EventEmitter<any> = new EventEmitter<any>();

  constructor(@Inject(NZ_MODAL_DATA) public data: any,) {
    super();



  }

  override ngAfterViewInit(): void {
    this.bayrak = structuredClone(this.data?.bayrak ?? {
      aciklama: "FikoYT Bayrak Açıklaması",
      baslik: "FikoYT",
      renkArka: "blue",
      renkYazi: "white",
    });
  }


  kapa() {
    this.kapandi.emit();
    this.CD.detectChanges();
    this.nzModalRef?.close();
    // this.kisilerChange.complete();
    // this.tiklandiKaydet.complete();
    // this.CD.detectChanges();

  }

  kaydetTiklandi() {
    this.CD.detectChanges();
    this.tiklandiKaydet.emit(this.bayrak ?? {
      aciklama: "FikoYT Bayrak Açıklaması",
      baslik: "FikoYT",
      renkArka: "blue",
      renkYazi: "white",
    });
    this.nzModalRef?.close({
      bayrak: this.bayrak ?? {
        aciklama: "FikoYT Bayrak Açıklaması",
        baslik: "FikoYT",
        renkArka: "blue",
        renkYazi: "white",
      }
    });
  }



  trackByMethod(index: number, el: any): number {
    return el._id;
  }

  override ngOnDestroy(): void {
    // $("#dialogKisiSecici" + this.id_dialog).remove();
    this.bayrakChange.complete();
    this.tiklandiKaydet.complete();
    super.ngOnDestroy();
  }
}
